import { authHeader, handleResponse } from '../helpers';
 
export const userService = {
    createUser,
    fetchRoleDLL,
    fetchDistDLL,
    fetchStateDDL,
    fetchCityDLL,
    updateUser,
    fetchUserData,
    inActiveRow,
    fetchUserApprovalData,
    approveUser,
    rejectUser,
    fetchUserDataExport,
    fetchWDLL,
    fetchSDLL,
    fetchRDLL,
    fetchASMDLL,
    fetchGDLL,
    createUserDetails
};
 
function fetchDistDLL(stateId) {
    ;
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };
 
  return fetch(`${process.env.REACT_APP_API_URL}UserDMaster/GetDistrictDLL/${stateId}`, requestOptions)
    .then(handleResponse);
}

function fetchCityDLL(districtId) {
    ;
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(`${process.env.REACT_APP_API_URL}UserDMaster/GetTownName/?cityId=${districtId}`, requestOptions)
    .then(handleResponse);
}
function fetchStateDDL(countryId){
  const requestOptions ={
    method :'GET',
    headers : authHeader(),
  };
  return fetch(`${process.env.REACT_APP_API_URL}/UserMaster/GetStateDLL/${countryId}`,requestOptions)
  .then(handleResponse);
}
// function fetchCityDLL(districtId) {
//     ;
//   const requestOptions = {
//     method: 'GET',
//     headers: authHeader(),
//   }; 
//   return fetch(`${process.env.REACT_APP_API_URL}UserDMaster/GetCityDLL/${districtId}`, requestOptions)
//     .then(handleResponse);
// } 

function createUser(data) {  
  debugger;
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };
    return fetch(`${process.env.REACT_APP_API_URL}UserMaster/CreateUser`, requestOptions)
        .then(handleResponse);
} 

function createUserDetails(data) {   
  // if data is FormData, send it directly, no JSON.stringify and no content-type header
  const isFormData = data instanceof FormData;
  const requestOptions = {
    method: "POST",
    headers: {
      // add auth header only if not FormData (because FormData needs no Content-Type header)
      ...(isFormData ? {} : authHeader()),
    },
    body: isFormData ? data : JSON.stringify(data),
  };
 
  return fetch(`${process.env.REACT_APP_API_URL}UserMaster/CreateUserDeatils`, requestOptions)
    .then(handleResponse);
} 

function fetchRoleDLL(userId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
 
    return fetch(`${process.env.REACT_APP_API_URL}UserMaster/GetRoleDLL/${userId}`, requestOptions)
        .then(handleResponse);
} 
function fetchWDLL(userId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
        
    };
 
    return fetch(`${process.env.REACT_APP_API_URL}WMaster/GetWarehouseDLL`, requestOptions)
        .then(handleResponse);
}
// services/userService.js
function fetchSDLL(RegionIds) {
  debugger
  ;
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };
 
  return fetch(`${process.env.REACT_APP_API_URL}WMaster/GetStateDLL/${RegionIds}`, requestOptions)
    .then(handleResponse);
}
 
function fetchRDLL(countryId) {
  ;
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }; 
  return fetch(`${process.env.REACT_APP_API_URL}UserDMaster/GetRegion`, requestOptions)
    .then(handleResponse);
} 
function fetchASMDLL(data) { 
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };
 
  return fetch(`${process.env.REACT_APP_API_URL}UserDMaster/GetSalesUserList`, requestOptions)
    .then(handleResponse);
}
 
function fetchGDLL() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };
 
  return fetch(`${process.env.REACT_APP_API_URL}WMaster/GetDealerGradeDLL`, requestOptions)
    .then(handleResponse);
}
 
function updateUser(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };
    return fetch(`${process.env.REACT_APP_API_URL}UserMaster/UpdateUser`, requestOptions)
        .then(handleResponse);
}
 
function fetchUserData(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };
 
    return fetch(`${process.env.REACT_APP_API_URL}UserMaster/GetUsers`, requestOptions)
        .then(handleResponse);
}
 
function fetchUserDataExport(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };
 
    return fetch(`${process.env.REACT_APP_API_URL}UserMaster/GetUserForExport`, requestOptions)
        .then(handleResponse);
}

function inActiveRow(userId, isActive) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(`${process.env.REACT_APP_API_URL}UserMaster/InActiveRow/${userId}/${isActive}`, requestOptions)
        .then(handleResponse);
}

function fetchUserApprovalData(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };
    return fetch(`${process.env.REACT_APP_API_URL}UserMaster/GetUsersForApproval`, requestOptions)
        .then(handleResponse);
}
function approveUser(userId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(`${process.env.REACT_APP_API_URL}UserMaster/ApproveUser/${userId}`, requestOptions)
        .then(handleResponse);
}
function rejectUser(userId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(`${process.env.REACT_APP_API_URL}UserMaster/RejectUser/${userId}`, requestOptions)
        .then(handleResponse);
}